import { StationStatusType } from '@/types/azk-list.types';

export const requiredFields = [
  { field: 'regional_office', label: 'Регіональне відділення' },
  { field: 'province', label: 'Область' },
  { field: 'division', label: 'Дивізіон' },
  { field: 'address', label: 'Адреса' },
  { field: 'status', label: 'Статус АЗК' },
  { field: 'start_date', label: 'Дата початку роботи' },
  { field: 'brand', label: 'Торгова марка (бренд)' },
  { field: 'station_number', label: 'Номер АЗК' },
  { field: 'latitude', label: 'GPS Широта' },
  { field: 'longitude', label: 'GPS Довгота' }
];

export const findId = (list?: { id: number; name: string }[], name?: string) =>
  list && name ? list.find(item => item.name === name)?.id : undefined;

export const getStatusKey = (
  statuses: { value: string; label: string }[],
  ukrainianStatus: string
): StationStatusType => {
  const statusOption = statuses.find(s => s.label === ukrainianStatus);
  return (statusOption ? statusOption.value : ukrainianStatus) as StationStatusType;
};
